// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"113":"7bff9a65","746":"47bbbdd7","941":"54d345f5"}[chunkId] + ".chunk.css";
};